module.exports = __webpack_public_path__ + "static/architecture-ae48511e73d7e6def3fbdf630610ca8e.png";